const admin = {
  fetched_accounts: false,
  fetching_accounts: false,
  fetching_settings: false,
  fetched_settings: false,
  fetching_subscriptions: false,
  fetched_subscriptions: false,
  fetching_users: false,
  fetched_users: false,
  fetching_projects: false,
  fetched_projects: false,
  fetching_costs: false,
  fetched_costs: false,
  fetching_prompts: false,
  fetched_prompts: false,
  fetching_partner_invites: false,
  fetched_partner_invites: false
};

const authentication = {
  user: false,
  cognito: false,
  fetched: false,
  fetching: false,
  auto_verifying_phone: false,
  auth_challenge: null // { type: 'MFA' | 'FORCE_PASSWORD', user }
};

const messages = {
  is_sending_message: false,
  list: [],
  project_fetched: {},
  project_fetching: false,
  last_fetched: null,
  fetched: false,
  fetching: false
};

const notes = {
  list: {},
  fetched: {},
  fetching: false,
  clinicalFindings: {},
  fetchedClinicalFindings: {},
  fetchingClinicalFindings: false
};

// Note templates are keyed per project scope ("<account_id>:<project_id|account>")
// so switching between projects doesn't show a stale list before refetch.
const noteTemplates = {
  list: {},
  fetched: {},
  fetching: false,
  saving: false
};

const calendar = {
  list: {},
  fetched: {},
  fetching: false
};

const loader = {
  show: false,
  message: "",
  timer: 30000,
  cancel: false
};

const plans = {
  list: [],
  last_fetched: null,
  fetched: false,
  fetching: false
};

const router = {
  pathname: "",
  search: "",
  hash: "",
  state: null,
  key: ""
};

const session = {
  account: false,
  customer: {},
  authorized: false,
  token: null,
  tab: null,
  ably_token: false,
  online_status: false,
  theme: "light",
  menu: false,
  launched: false,
  onboarded: false,
  iosPrompted: false,
  workerActive: false,
  newVersionAvailable: false,
  hide_bars: false,
  last_logged_in: false,
  logging_out: false,
  device_id: false,
  unread_chats: 0,
  settings: false,
  idle: false,
  last_active: null,
  session_start_time: null,
  locked: {
    show: false,
    inactive: false
  },
  onboarding_step: 0,
  allow_lock_screen: false,
  remember_me: true,
  auth: false,
  showFocusChat: false,
  onboarding_people: false,
  onboarding_documents: false,
  onboarding_categories: false,
  onboarding_welcome: false,
  onboarding_done: false,
  // Modal/Popup states (persist across Redux updates)
  showSMSSetup: false,
  smsJustEnabled: false,
  defaultSmsJustSet: false,
  showSMSDisclosure: false,
  showConfetti: false,
  unlockModalOpen: false,
  showHelpModal: false,
  unlockModalDismissed: false,
  hasTriggeredConfetti: false
};

const accounts = {
  list: [],
  current: false,
  primary: false,
  fetched: false,
  fetching: false
};

const partners = {
  list: [],
  fetchedAccounts: false,
  fetchingAccounts: false,
  fetchingInvites: false,
  fetchedInvites: false,
  invites: [],
  fetched_all_accounts: null,
  fetched_all_invites: null,
  surveys: [],
  fetchedPartnerSurveys: false,
  fetchingPartnerSurveys: false,
  populationHealth: null,
  fetchedPopulationHealth: false,
  fetchingPopulationHealth: false
};

const users = {
  list: [],
  fetched: false,
  fetching: false,
  fetched_all: null
};

const transactions = {
  list: [],
  fetched: false,
  fetching: false,
  fetched_all: null
};

const notification = {
  message: "",
  timeout: 10000,
  action: "",
  button_text: "",
  hide_close: true,
  type: "", // error, success, warning, danger
  pages: [] // what pages should this display on? empty array will show on all pages
};

const projects = {
  list: {},
  fetched: false,
  fetching: false,
  survey: false,
  survey_open: false,
  loading_blocks: [],
  document: [],
  original_document: [],
  promptSuccess: { show: false },
  fetched_all: null,
  adaptive: { show: false, config: {} },
  plan_complete: false,
  quickLook: false,
  total: 0
};

const blocks = {
  list: [],
  fetched: {},
  fetching: false
};

const responses = {
  list: {},
  fetched: {},
  fetching: false
};

const segments = {
  list: {},
  fetched: {},
  fetching: false
};

const prompts = {
  list: {},
  fetched: {},
  fetching: false,
  queries: {
    list: [],
    fetched: {},
    fetching: false
  },
  prompt_reminders: 0,
  activeConversationId: null
};

const medications = {
  list: {},
  fetched: {},
  fetching: false,
  creating_medication: false,
  fetched_all: null
};

const contacts = {
  list: {},
  fetched: {},
  fetching: false,
  creating_contact: false,
  fetched_all: null
};

const profiles = {
  list: {},
  fetched: {},
  fetching: false
};

const navigation = {
  list: {
    all: []
  },
  fetched: {},
  fetching: false
};

const documents = {
  list: {},
  fetched: {},
  fetching: false,
  creating_document: false,
  usage: {},
  fetched_all: null
};

const coverage = {
  by_project: {}, // project_id -> payload
  fetched: {},
  fetching: false
};

const modal = {
  show: false,
  data: {}
};

// One Tap minimal defaults (interaction & gating only)
const oneTap = {
  interactionTs: null,
  suppressed: false,
  prompted: false
};

const defaults = {
  admin,
  session,
  accounts,
  users,
  contacts,
  authentication,
  loader,
  notification,
  projects,
  blocks,
  responses,
  segments,
  prompts,
  documents,
  coverage,
  medications,
  router,
  modal,
  plans,
  profiles,
  transactions,
  partners,
  messages,
  navigation,
  notes,
  noteTemplates,
  calendar,
  oneTap
};

export default defaults;
